/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalInsuredResponseDto } from './AdditionalInsuredResponseDto';
import type { AddressResponseDto } from './AddressResponseDto';
import type { AdviserLinkResponseDto } from './AdviserLinkResponseDto';
import type { AdviserSummaryDto } from './AdviserSummaryDto';
import type { MainContactResponseDto } from './MainContactResponseDto';
export type ClientResponseDto = {
    /**
     * Unique client identifier (UUID)
     */
    id: string;
    /**
     * Title (MR, MRS, MS, DOCTOR, etc. — uppercase Ando values)
     */
    title?: string | null;
    /**
     * First name (for INDIVIDUAL clients) or business name (for BUSINESS clients)
     */
    firstName: string;
    /**
     * Last name (for INDIVIDUAL clients). For BUSINESS clients, this may be empty.
     */
    lastName: string;
    /**
     * Date of birth (for INDIVIDUAL clients)
     */
    dob?: string | null;
    /**
     * Gender (for INDIVIDUAL clients)
     */
    gender?: ClientResponseDto.gender | null;
    /**
     * Type of client
     */
    clientType: ClientResponseDto.clientType;
    /**
     * Client status
     */
    status: ClientResponseDto.status;
    /**
     * Primary phone number
     */
    phone: string;
    /**
     * Primary email address
     */
    email: string;
    /**
     * UUID of the assigned adviser
     */
    assignedAdviserId?: string;
    /**
     * Assigned adviser details
     */
    assignedAdviser?: AdviserSummaryDto | null;
    /**
     * Company registration number (for BUSINESS clients)
     */
    companyRegNo?: string | null;
    /**
     * Trading as name (for BUSINESS clients)
     */
    tradingAs?: string | null;
    /**
     * GST number (for BUSINESS clients)
     */
    gstNumber?: string | null;
    /**
     * Ando customer_id (set after async Ando customer sync)
     */
    andoCustomerId?: string | null;
    /**
     * Ando customer_code (set after async Ando customer sync)
     */
    andoCustomerCode?: string | null;
    /**
     * Timestamp when Ando customer was last synced successfully
     */
    andoCustomerSyncedAt?: string | null;
    /**
     * Last Ando customer sync error (set when async sync fails or is skipped due to missing data)
     */
    andoCustomerSyncError?: string | null;
    /**
     * Flag indicating if client is vulnerable
     */
    isVulnerable: boolean;
    /**
     * Flag indicating if client has policies with other providers
     */
    hasMultiplePolicies: boolean;
    /**
     * Unallocated cash held on account for this client
     */
    unallocatedCash: number;
    /**
     * Manually added unallocated cash (not tied to an invoice)
     */
    manualUnallocatedCash: number;
    /**
     * Total unallocated cash (invoice credits + manual credits)
     */
    totalUnallocatedCash: number;
    /**
     * Additional notes about the client
     */
    notes?: string | null;
    /**
     * Main contact details (only for BUSINESS clients)
     */
    mainContact?: MainContactResponseDto | null;
    /**
     * Last activity timestamp
     */
    lastActivity?: string | null;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
    /**
     * UUID of the user who created this client
     */
    createdBy?: string | null;
    /**
     * UUID of the user who last updated this client
     */
    updatedBy?: string | null;
    /**
     * Adviser links (Authorised Rep and Servicing Adviser assignments)
     */
    adviserLinks?: Array<AdviserLinkResponseDto> | null;
    /**
     * List of addresses for the client
     */
    addresses?: Array<AddressResponseDto> | null;
    /**
     * List of additional insured persons
     */
    additionalInsureds?: Array<AdditionalInsuredResponseDto> | null;
};
export namespace ClientResponseDto {
    /**
     * Gender (for INDIVIDUAL clients)
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Type of client
     */
    export enum clientType {
        INDIVIDUAL = 'INDIVIDUAL',
        BUSINESS = 'BUSINESS',
    }
    /**
     * Client status
     */
    export enum status {
        IN_PROGRESS = 'IN_PROGRESS',
        BOUND = 'BOUND',
        LAPSED = 'LAPSED',
        RENEWAL_DUE = 'RENEWAL_DUE',
    }
}

